import { routeHead } from './route-head';

export function dealerHead(path: string, name: string | null, city: string | null) {
  const base = routeHead(path);
  if (!name) return { ...base, meta: [...base.meta.filter(item => item.name !== 'robots'), { name: 'robots', content: 'noindex, follow' }] };
  const title = `${name} | RO Auto Market`;
  const description = `${name}${city ? ` din ${city}` : ''}. Vezi anunțurile active și contactează direct dealerul pe RO Auto Market.`;
  return { ...base, meta: base.meta.map(item => {
    if ('title' in item) return { title };
    if (item.name === 'title' || item.property === 'og:title' || item.name === 'twitter:title') return { ...item, content: title };
    if (item.name === 'description' || item.property === 'og:description' || item.name === 'twitter:description') return { ...item, content: description };
    return item;
  }) };
}